import React from 'react'
import Banner from '../Compnents/Home/Banner'
import Features from '../Compnents/Home/Features'
import Testimonials from '../Compnents/Home/Testimonials'
import NewsLetter from '../Compnents/Home/NewsLetter'

const Home = () => {
    return (
        <>
            <Banner />
            <Features />
            <Testimonials />
            <NewsLetter />
        </>
    )
}

export default Home